export default __webpack_public_path__ + "9242107df7da7c6ad3cadf3133abcd37.ttf";